import reduceReducers from 'reduce-reducers';

import practitionerReducer from './practitioner-reducer';
import bookingReducer from './bookingTimeSlot-reducer';
import stepReducer from './step-reducer';
import storePersistReducer from './store-persist-reducer';

export default reduceReducers(
  practitionerReducer,
  bookingReducer,
  stepReducer,
  storePersistReducer,
);
